import {Injectable} from "@angular/core";
import { EstimatedDesignRuntime, DefaultService } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class EstimatedDesignRuntimeService {
    constructor(private powerSupplyService: DefaultService) {
        this.getEstimatedDesignRuntimes();
    }

    public getEstimatedDesignRuntimes() {
        return this.powerSupplyService.getEstimatedDesignRuntimes()
            .pipe(map(result => result));
    }

    public createEstimatedDesignRuntime(model: EstimatedDesignRuntime) {
        return this.powerSupplyService.createEstimatedDesignRuntime(model)
            .pipe(map(result => result));
    }

    public updateEstimatedDesignRuntime(model: EstimatedDesignRuntime) {
        return this.powerSupplyService.updateEstimatedDesignRuntime(model)
            .pipe(map(result => result));
    }

    public deleteEstimatedDesignRuntime(id: number) {
        return this.powerSupplyService.deleteEstimatedDesignRuntime(id)
            .pipe(map(result => result));
    }
}
